export default function(ngModule) {
    ngModule.factory('Whitelabel', function(BaseClass,$q, $http) {

        const urlPrefix = AUTH_API_ROOT;

        /**
         * Constructor function
         *
         * @param {Object} attributes Initial attributes for the model
         */
        function Whitelabel(attributes) {
            _.assign(this,attributes);
        }
        Whitelabel.modelName = 'Whitelabel';


        BaseClass.apply(Whitelabel);

        Whitelabel.validates({
            name: {
                required: true
            },
            locale: {
                required: true,
                format: {
                    regex: {
                        regex: /^[a-z]{2,3}(_(Cyrl|Latn|Cans|Mong))?_([A-Z]{2})$/,
                        message: 'Must be a valid locale'
                    }
                }
            },
            website: {
                required: true,
                format: {
                    regex: {
                        regex: /^https?:\/\/(?:[a-z0-9]+\.)+[a-z]+.*/i,
                        message: 'Must be a valid URL'
                    }
                }
            },
            from_name: {
                required: true
            },
            from_email: {
                required: true
            },
            order_base: {
                required: true
            }
        });

        Whitelabel.configureApi(urlPrefix + '/whitelabel/:guid');

        Object.defineProperty(Whitelabel.prototype, 'toString', {
            value: function() {
                return this.name;
            },
            enumerable: false,
            configurable: false
        });

        /**
         * Assign a company to this whitelabel
         *
         * @return {HTTPResponse} Promise which resolves to empty http response if successful
         */
        Object.defineProperty(Whitelabel.prototype, 'assign', {
            value: function(companyGuid) {
                return $http.post(urlPrefix + `/whitelabel/${this.guid}/assign/${companyGuid}`);
            },
            enumerable: false,
            configurable: false
        });

        /**
         * Get OAuth client credentials for this whitelabel
         *
         * @return {HTTPResponse} Promise to deliver credentials, {id, secret}
         */
        Object.defineProperty(Whitelabel.prototype, 'client', {
            value: function() {
                return $http.get(urlPrefix + `/whitelabel/${this.guid}/client`);
            },
            enumerable: false,
            configurable: false
        });

        /**
         * Undelete a whitelabel
         *
         * @return {HTTPResponse} Promise
         */
        Object.defineProperty(Whitelabel.prototype, 'reinstate', {
            value: function() {
                return $http.post(urlPrefix + `/whitelabel/${this.guid}/reinstate`);
            },
            enumerable: false,
            configurable: false
        });

        /**
         * Regenerate whitelabel oauth client credentials
         *
         * @return {HTTPResponse} Promise to deliver credentials, {id, secret}
         */
        Object.defineProperty(Whitelabel.prototype, 'clientRecreate', {
            value: function() {
                return $http.post(urlPrefix + `/whitelabel/${this.guid}/client/recreate`);
            },
            enumerable: false,
            configurable: false
        });

        return Whitelabel;
    });
}
